// extracted by mini-css-extract-plugin
module.exports = {"projectsStyles":"pages-projects-styles__projectsStyles"};